type FeatureCardProps = {
  iconClass: string;
  title: string;
  description: string;
};

export default function FeatureCard({
  iconClass,
  title,
  description,
}: FeatureCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="w-10 h-10 bg-violet-50 rounded-lg flex items-center justify-center mb-4">
        <i className={`${iconClass} text-xl text-violet-500`}></i>
      </div>
      <h3 className="text-lg font-semibold text-slate-900 mb-2">{title}</h3>
      <p className="text-sm text-slate-600 leading-relaxed">{description}</p>
    </div>
  );
}
